/** Shared layout tokens so browse / configure / session stay visually consistent. */
export const SCENARIO_PAGE_SHELL = {
  content: "mx-auto w-full max-w-4xl space-y-4",
  contentSession:
    "mx-auto flex min-h-0 w-full max-w-6xl flex-1 flex-col gap-3 overflow-hidden space-y-0 pt-1 md:pt-2",
  card: "border-2 border-bodhi-gold/30 bg-white shadow-md",
  chatCard: "flex min-h-0 flex-1 flex-col overflow-hidden border-2 border-bodhi-gold/40 bg-white p-0 shadow-md",
} as const;
